import rambbbleHeader from "../images/Rambbble-header.png";
import nftSopeHeader from "../images/nftScopeHeader.png";
import dalukwaHeader from "../images/dalukwaHeader.png";
import simiHeader from "../images/simi.png";
import surveyLakeHeader from "../images/surveylake.png";
import ITCHeader from "../images/ITC-image.png";
import LumosHeader from "../images/BuidlCrew.png";
export const worksConfig = [
  {
    id: 1,
    title: "Mado App",
    image: "",
    link: "https://www.madoapp.com/",
    description:
      "Mado helps curate unique activities and fun experiences, making every moment feel like an adventure",
    roles: [
      "designed and built the waitlist landing page",
      "created an engaging user interface with animations",
      "integrated social media connections and email signup",
    ],
  },
  {
    id: 2,
    title: "infra-tech",
    image: ITCHeader,
    link: "https://infra-techconsulting.com/",
    description:
      "Infra-tech consulting provides innovative solutions for pipeline security",
    roles: [
      "designed the user interface and experience",
      "built the website and set up an Emailing system",
      "designed a flexible content management system with Prismic",
    ],
  },
  {
    id: 3,
    title: "simi olabisi",
    image: simiHeader,
    link: "https://simiolabisi.com",
    description:
      "A portofolio website created for simi olabisi, an AI thought leader at Microsoft",
    roles: [
      "designed the user interface and experience",
      "built the website and integrated with an headless CMS",
      "designed a flexible content management system",
    ],
  },
  {
    id: 4,
    title: "dalukwa",
    image: dalukwaHeader,
    link: "https://dalukwa.com/",
    description:
      "dalukwa is a p2p platform that enables users to create/search for competitive 1 vs 1 duels from sport games, and win cash prizes",
    roles: [
      " collaborated with designers & devs to build responsive web screens",
      "managed complex application states",
      "integrated the frontend with api endpoints",
    ],
  },
  {
    id: 5,
    title: "Myriadflow",
    image: "",
    link: "https://myriadflow.com/",
    description:
      "Myriadflow is an AI-powered no-code NFT platform empowering brands and creators to embrace Web3 innovation and extended reality",
    roles: [
      "built ui screens and particpated in hackathons with the team",
      "implemented interactive AI-powered experience showcases",
      "integrated Web3 and NFT marketplace features",
    ],
  },
  {
    id: 6,
    title: "lumos buidl",
    image: LumosHeader,
    link: "https://lumos-crew.netlify.app/",
    description:
      "The BUIDL Crew by Lumos Labs is an all-exclusive community for developers.",
    roles: [
      "designed the user interface of the landing page",
      "built the page with nextjs",
      "added interactive animations with GSAP",
    ],
  },
  {
    id: 7,
    title: "My E-station",
    image: "",
    link: "https://www.my-estation.com/",
    description:
      "My-eStation is a development studio specializing in creating innovative digital products and services for connected world",
    roles: [
      "developed digital products for the company's clients",
      "built custom web applications and platforms",
      "collaborated with the team on various client projects",
    ],
  },
  {
    id: 8,
    title: "Surveylake",
    image: surveyLakeHeader,
    link: "https://surveylake.com/",
    description:
      "Surveylake helps to gather feedback to help improve customer relations, promote employee engagement, and uncover product development opportunities",
    roles: [
      "building Figma designs into responsive web screens with NextJs and Tailwind CSS",
      "collaborated with the CTO in choosing the suitable tools and frameworks",
      "actively participating in design reviews and setting KPIs",
    ],
  },
  {
    id: 9,
    title: "rambbble",
    image: rambbbleHeader,
    link: "https://www.rambbble.com/",
    description:
      "rambble connects people with the same passion – traveling! our goal is to help you find travel buddies and make new friends",
    roles: [
      " built the landing page and advised on better ux strategies",
      "built a controlled waitlist form for intending users",
      "integrated the form data to emailjs mailing system",
    ],
  },
  {
    id: 10,
    title: "ALC",
    image: "",
    link: "https://amaloversclub.com/",
    description:
      "AMA Lovers Club (ALC) is a dedicated decentralized cryptocurrency community exploring interesting projects for financial freedom",
    roles: [
      "designed and developed the community platform",
      "integrated crypto price tracking features",
      "built partner and client showcase sections",
    ],
  },
  {
    id: 11,
    title: "nftscope",
    image: nftSopeHeader,
    link: "https://nftscopebysam.netlify.app/",
    description:
      "nftscope displays a gallery of ethereum chain nfts present in a wallet",
    roles: [
      "set up wallet connection to the react app using connectkit",
      "tracked wallet connection states using wagmi.sh",
      "fetched nft and token collection data from alchemysdk",
    ],
  },
];
